import api from "api";

const dashboardStatistics = {
    get: (params) => {
        return api().get('/dashboard/statistics', {
            params: { ...params }
        });
    },
}

export default dashboardStatistics;
